export default "__VITE_ASSET__d22c24bf__"